export default "__VITE_ASSET__BANXP_Cq__"